import Landmark from 'Landmark'

export default class CityHall extends Landmark {}